export const environment = {
  fleetApiUrl: '__FLEETHUB_API_URL__',
  logUiUrl: '__LOGUI_APP_URL__',
  b2cDomain: '__B2C_DOMAIN__',
  b2cClientId: '__B2C_CLIENTID__',
  b2cTenantId: '__B2C_TENANTID__',
  b2cBeScope: '__B2C_BE_SCOPE__',
  entraDomain: '__ENTRA_DOMAIN__',
  entraTenantId: '__ENTRA_TENANTID__',
  entraClientId: '__ENTRA_CLIENTID__',
  entraScopes: '__ENTRA_SCOPES__',
  featureFlags: '__FEATURE_FLAGS__',
};
